import { OrderedMap } from 'immutable';
import { catchError } from '../apiUtils';
export const getTeasers = (ids)=>new Promise(async (res)=>{
        // Add XSRF token to headers
        let headers = new Headers();
        headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
        try {
            // Build params
            const searchParams = new URLSearchParams();
            ids.forEach((id)=>searchParams.append("entityIds", id));
            let teasers = await fetch(`/api/v1/search/getByIds?${searchParams.toString()}`, {
                headers
            }).then((x)=>x.status == 200 ? x.json() : Promise.reject(x.statusText)).then((x)=>x.map((item)=>({
                        id: item.EntityId.toString(),
                        title: item.Title,
                        url: item.Url,
                        imageUrl: item.ImageUrls["400x280"],
                        imageUrlFallback: item.ImageUrls["4x3"],
                        imageUrlLarge: item.ImageUrls["800x560"],
                        imageAlt: item.ImageAlt,
                        description: item.Description
                    }))).catch(catchError());
            if (teasers == 'error' || teasers == 'loading') throw new Error('Could not load teasers');
            res(OrderedMap(teasers.map((t)=>[
                    t.id,
                    t
                ])));
        } catch (e) {
            console.error(e);
            res('error');
        }
    });
